import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { SopoConfirmData } from '../../interfaces/confirm';
import { AuthStoreDispatcher } from 'src/app/core/state/auth/auth.dispatcher';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';
import AppLauncherElectron from 'src/app/plugins/app-launcher.plugin';
import { isElectron } from 'src/app/shared/utils/platform.utils';

@Component({
    selector: 'app-sopo-confirm',
    templateUrl: './sopo-confirm.component.html',
    styleUrls: ['./sopo-confirm.component.scss'],
    standalone: false
})
export class SopoConfirmComponent implements OnInit, OnDestroy {
    dismissAfterTimeout: NodeJS.Timeout;

    header: string = '';
    body: string = '';
    warning: string = '';
    dontShowAgain: string = '';
    dismissAfter: number = 0;
    okText: string = 'Ok';
    cancelText: string = 'Cancel';
    verifiedLanguage: boolean = false;

    constructor(
        @Inject(SOPO_DIALOG_DATA) data: SopoConfirmData,
        private authDispatcher: AuthStoreDispatcher,
        private sopoDialogRef: SopoDialogRef,
    ) {
        if (data.header) this.header = data.header;
        if (data.body) this.body = data.body;
        if (data.warning) this.warning = data.warning;
        if (data.dontShowAgain) this.dontShowAgain = data.dontShowAgain;
        if (data.dismissAfter) this.dismissAfter = data.dismissAfter;
        if (data.okText) this.okText = data.okText;
        if (data.cancelText) this.cancelText = data.cancelText;
        if (data.verifiedLanguage) this.verifiedLanguage = data.verifiedLanguage;
    }

    ngOnInit() {
        if (this.dismissAfter && this.dismissAfter > 0) {
            this.dismissAfterTimeout = setTimeout(() => {
                this.close(false);
            }, this.dismissAfter);
        }
    }

    async dontShow(event) {
        const myId = await this.authDispatcher.getMyID();
        const itemKey = `dontShowAgain_${this.dontShowAgain}_${myId}`;
        if (event.detail.checked) {
            localStorage.setItem(itemKey,'true');
        } else {
            localStorage.removeItem(itemKey);
        }
    }

    close(answer: boolean) {
        this.sopoDialogRef.close(answer);
    }

    openLink(link: string) {
        if (isElectron()) AppLauncherElectron.openUrl({ url: link });
        else window.open(link, '_blank');
    }

    ngOnDestroy(): void {
        if (this.dismissAfterTimeout) clearTimeout(this.dismissAfterTimeout);
    }
}
